module.exports = __webpack_public_path__ + "img/no-jobs.570efdfc.svg";